fx.ns("filters", class ProductFilter extends fx.Filter {

	constructor()
	{
        super();
    }

    get productType()
    {
        return this._productType;
    }

    set productType(val)
    {
        this._productType = val;
        this._changed = true;
        this.trigger("updated");
    }

    get idLang()
    {
        return this._idLang;
    }

    set idLang(val)
    {
        this._idLang = val;
        this._changed = true;
        this.trigger("updated");
    }

    exec()
	{
        if (!this.rawData)
            return;

        this.transformedData = [];
        
        for (let i = 0; i < this.rawData.length; i++)
        {
            let product = this.rawData.getItemAt( [i] );

            if (product.product_type_id != this.productType)
                continue;

            if (product.id_lang != this.idLang)
                continue;

            this.transformedData.push( product );
        }

		return this.transformedData;
	}	

    
});